import { Component, OnInit, Inject } from '@angular/core';
import {
  FormGroup,
  Validators,
  FormControl,
} from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { UserSessionService } from '../../services/user-session.service';
import { LibConfiguration } from '../../lib-configuration';
import { LIB_CONFIG } from '../../lib-configuration-token';
import { ToastrService } from 'ngx-toastr';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
})
export class LoginComponent implements OnInit {
  returnUrl: string;
  form = new FormGroup({
    user_email: new FormControl('', Validators.required),
    password: new FormControl('', Validators.required),
  });

  constructor(
    public router: Router,
    public route: ActivatedRoute,
    public authService: AuthService,
    public userSessionServie: UserSessionService,
    @Inject(LIB_CONFIG) public config: LibConfiguration,
    private toastr: ToastrService,
    private dialog: MatDialog
  ) {
    // navigate to home if the user is logged in
    if (this.userSessionServie.currentUser) {
      this.router.navigate(['/']);
    }
  }

  ngOnInit() {
    this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';
    const body = document.getElementsByTagName('body')[0];
    body.classList.add('login-page');
    body.classList.add('off-canvas-sidebar');
    this.dialog.closeAll();
  }

  onSubmit(): void {
    if (this.form.valid) {
      this.authService.login(this.form.value).subscribe(
        () => {
          this.router.navigate([this.returnUrl]);
          this.toastr.success(
            'Sikeres bejelentkezés!'
          );
        },
        (error) => {
          let errorMessage: string;
          switch (error.status) {
            case 400:
              errorMessage = 'Rossz e-mail cím vagy jelszó!';
              break;
            default:
              errorMessage = 'Hiba a bejelentkezéskor! (' + error.status + ')';
              break;
          }
          this.toastr.error(errorMessage);
        }
      );
    } else {
      for (const control in this.form.controls) {
        if (this.form.controls[control].errors) {
          (document.querySelector('input[formControlName="'+ control +'"]') as HTMLElement).focus();
          return;
        }
      }
    }
  }
}
